export const setModalFocus = () => {
  setTimeout(() => {
    if (document.querySelector('.modal-container .modal-buttons button')) {
      ;(
        document.querySelector(
          `.modal-container .modal-buttons button`
        ) as HTMLElement
      ).focus()
    }
  })
}
